import { getLocationsSnapshotsApi } from './api';
import { Toast } from '../../components/Toast';

export const getLocationsSnapshots = (getAccount, locationId) =>
  getLocationsSnapshotsApi(getAccount())
    .locationConfigurationSnapshotGetByLocation(locationId)
    .then(result => result.data)
    .catch(error => {
      const { response = {} } = error;
      const {
        data = 'Error during getting location snapshots. Please try again or contact with system administrator'
      } = response;

      Toast.showToast({
        message: data,
        colorType: 'Danger'
      });

      return Promise.reject(error);
    });

export const restoreLocationConfigurationBySnapshot = (
  getAccount,
  locationId,
  snapshotId
) =>
  getLocationsSnapshotsApi(getAccount())
    .locationConfigurationSnapshotRestore(locationId, snapshotId)
    .then(result => result.data)
    .catch(error => {
      const { response = {} } = error;
      const {
        data = 'Error during restoring location from snapshot. Please try again or contact with system administrator'
      } = response;

      Toast.showToast({
        message: data,
        colorType: 'Danger'
      });

      return Promise.reject(error);
    });
